import { USER_ME, USER_ME_FAILURE, USER_ME_SUCCESS } from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const userMeReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ME:
      return { ...state, loading: true };
    case USER_ME_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case USER_ME_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default userMeReducer;
